import { render, staticRenderFns } from "./CategoryPage.vue?vue&type=template&id=7705256e&scoped=true"
import script from "./CategoryPage.vue?vue&type=script&lang=js"
export * from "./CategoryPage.vue?vue&type=script&lang=js"
import style0 from "./CategoryPage.vue?vue&type=style&index=0&id=7705256e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7705256e",
  null
  
)

export default component.exports